import { DiceRollActionTypes } from "@/constants";
import type { DiceRollEventPayload } from "@/types";
import type { User } from "@dndbeyond/auth/types/user";
import type { Platform } from "@dndbeyond/event-pipeline-lib/shared";
import { sendEvent } from "./sendEvent";

export const instrumentDiceRoll = async (
  user: User,
  {
    audience,
    diceRolled,
    diceSet,
    results,
    rollId,
    total,
    type,
    action,
    kind,
    isDm,
    eventType,
  }: DiceRollEventPayload,
  platform: Platform,
  location: string,
  gameId?: number,
  playSessionId?: string,
  env?: string,
) => {
  try {
    await sendEvent(
      user,
      "GAME_ACTION",
      {
        gameId,
        playSessionId,
        actionTaken: "dice_roll",
        actionDescriptors: [
          {
            rollId,
            diceRolled,
            results,
            total,
            type,
            action,
            diceSet,
            audience,
            location,
            isDm,
            ...(kind && { kind }),
            is3d: eventType === DiceRollActionTypes.Deferred ? true : false,
          },
        ],
      },
      platform,
      undefined,
      env,
    );
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);

    console.warn(message, {
      exception: error,
      location: `${platform} > ${location} > instrumentDiceRoll`,
    });
  }
};
